import * as clientMasterAction from './client-master-action'

export {
  clientMasterAction,
}



// WEBPACK FOOTER //
// ./src/actions/client/index.js